"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var PercentageStackColumn = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageStackColumn, _super);
    function PercentageStackColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PercentageStackColumn.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'percentageStackColumn';
        _super.prototype.createLayers.call(this, layerProps);
    };
    PercentageStackColumn.getDefaultOptions = layer_1.default.getDefaultOptions;
    return PercentageStackColumn;
}(plot_1.default));
exports.default = PercentageStackColumn;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/percentage-stack-column/index.js
// module id = 943
// module chunks = 37